<template>
  <div class="row">
    <div class="mx-auto col-md-12">
      <div class="card p-3 mb-3">
        <div class="card-body">
          <beneficiarioHeader
            :cpf_requerente="familia.cpf_requerente"
            :nome_completo="familia.nome_completo"
            :situacao="familia.ind_ativo"
          >
          </beneficiarioHeader>
          <b-card class="mb-2" header="Benefícios" header-tag="header">
            <b-row>
              <b-col>
                <b-alert
                  variant="warning"
                  :show="familia.beneficio_familia == null"
                >
                  <h6 class="alert-heading">
                    <font-awesome-icon
                      :icon="['fas', 'exclamation-triangle']"
                    />
                    &nbsp;Não houve aceite do benefício pelo beneficiário.
                  </h6></b-alert
                >
              </b-col>
            </b-row>
            <b-form>
              <b-form-group
                label=""
                class="mb-0"
                :disabled="
                  !$store.getters.userRoles.includes(
                    $constantes.usuario.ROLES.SUPERADMINISTRADOR
                  )
                "
              >
                <b-form-checkbox
                  v-for="beneficio in beneficios"
                  :key="beneficio.id"
                  v-model="beneficio.aceite"
                  value="S"
                  unchecked-value="N"
                  @change="alteraDados(beneficio)"
                >
                  {{ beneficio.nome_beneficio }}

                  <font-awesome-icon
                    :id="`b-${beneficio.id}`"
                    class="mr-2"
                    :icon="['fas', 'question-circle']"
                  />

                  <b-tooltip :target="`b-${beneficio.id}`" triggers="hover">
                    {{ beneficio.termo_beneficio }}
                  </b-tooltip>
                </b-form-checkbox>
              </b-form-group>
            </b-form>
            <template v-slot:footer>
              <b-row>
                <b-col class="text-left">
                  <b-button
                    variant="outline-secondary"
                    @click.prevent="voltar"
                    title="Voltar"
                  >
                    <font-awesome-icon
                      :icon="['fas', 'arrow-left']"
                      title="Voltar"
                      class="mr-1"
                    />
                    Voltar
                  </b-button>
                </b-col>
                <b-col class="text-right">
                  <b-button
                    variant="success"
                    @click.prevent="salvar"
                    v-if="
                      $store.getters.userRoles.includes(
                        $constantes.usuario.ROLES.SUPERADMINISTRADOR
                      )
                    "
                    title="Salvar"
                  >
                    <font-awesome-icon
                      :icon="['fas', 'save']"
                      title="Salvar"
                      class="mr-1"
                    />
                    Salvar
                  </b-button>
                </b-col>
              </b-row>
            </template>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Familia from "../../../models/Familia";
import Beneficio from "../../../models/Beneficio";
import beneficiarioHeader from "../../../components/BeneficiarioHeader";

export default {
  components: {
    beneficiarioHeader,
  },

  data() {
    return {
      formAlterado: false,
      familia: new Familia(),
      beneficios: [],
    };
  },

  methods: {
    alteraDados(beneficio) {
      this.formAlterado = true;
      this.familia.ind_beneficio_ej = beneficio.aceite;
    },

    obterPermissaoBeneficiosFamilia() {
      return this.$api
        .get(`familias/${this.$route.params.id}/permissao-beneficios`)
        .then((response) => {
          this.familia = new Familia(response.data.dados);
          this.obterBeneficios();
        })
        .catch((error) => {
          this.$helpers.showToast(
            this,
            "Erro",
            error.response.data.message,
            "danger"
          );
        });
    },

    obterBeneficios() {
      this.$api
        .get("beneficios")
        .then((response) => {
          response.data.dados.forEach((element) => {
            let beneficio = new Beneficio(element);
            if (this.familia.beneficio_familia) {
              beneficio.aceite =
                this.familia.beneficio_familia.beneficio_ativo == "A"
                  ? "S"
                  : "N";
              this.beneficios.push(beneficio);
            }
          });
        })
        .catch((error) => {
          this.$helpers.showToast(
            this,
            "Erro",
            error.response.data.message,
            "danger"
          );
        });
    },

    salvar() {
      var msg = this.beneficios[0].aceite == 'N' ? 'inativar o benefício? Caso sim, o beneficiário e o pagamento em aberto serão inativados também.' : 'ativar o benefício?';
      this.$helpers
        .modalConfirmacao(
          this,
          "Editar Benefício",
          "Deseja realmente "+msg,
          "md",
          "primary",
          "SIM"
        )
        .then((value) => {
          if (value) {
            this.$api
              .put(
                `familias/${this.$route.params.id}/permissao-beneficios`,
                this.familia
              )
              .then((response) => {
                this.formAlterado = false;
                this.familia = new Familia(response.data.dados);
                this.$helpers.showToast(
                  this,
                  "Sucesso",
                  "Benefício atualizado com sucesso.",
                  "success"
                );
              })
              .catch((error) => {
                this.$helpers.showToast(
                  this,
                  "Erro",
                  error.response.data.message,
                  "danger"
                );
              });
          }
        });
    },

    voltar() {
      if (this.formAlterado) {
        this.$helpers.confirmaVoltar(this).then((confirmado) => {
          if (confirmado) {
            this.$router.push({ name: "beneficiarios" });
          }
        });
      } else {
        this.$router.push({ name: "beneficiarios" });
      }
    },
  },

  async mounted() {
    await this.obterPermissaoBeneficiosFamilia();
  },
};
</script>

<style scoped>
.labelInvalid {
  color: rgb(250, 4, 4);
  font-size: 0.83em;
}
</style>
